import React from 'react'

const Footer = () => {
  return (
    <footer className="footer">
        <div className="footer__container container">
            <p>© {new Date().getFullYear()} - Анкетирование УКО ДГУ</p>
        </div>
    </footer>
  )
}

export default Footer